import { CSSProperties, FC, useEffect, useRef } from 'react';

import { EChartsOption } from 'echarts/types/dist/echarts';

import { Echarts } from './Echarts';

type Props = {
	options: EChartsOption;
	style?: CSSProperties;
};

export const EchartsReact: FC<Props> = ({ options, style }): JSX.Element => {
	const chartRef = useRef(null);

	useEffect(() => {
		if (chartRef.current) {
			const chart = chartRef.current;
			const finallyOptions: EChartsOption = {
				...options,
				tooltip: {
					...options?.tooltip,
					renderMode: 'html',
					appendTo: 'body',
				},
				legend: {
					...options?.legend,
					textStyle: {
						color: '#627491',
					},
				},
				textStyle: {
					fontFamily: 'Lato',
				},
			};

			// Устанавливаем опции для графика
			//@ts-ignore
			chart.setOption(finallyOptions, true);
		}
	}, [options]);

	return <Echarts chartsRef={chartRef} className="chart" style={style} />;
};
